import { _baseDeleteFetch, _baseGetFetch, _basePostFetch, _basePutFetch, ApiEnum } from './baseFetch'

const path = '/units-languages'
const pageLimit = 20

export const getUnitsLanguagesLocales = async () => {
  return _baseGetFetch(`${path}/locale`, undefined, ApiEnum.admin)
}

export const getUnitsLanguagesProducts = async () => {
  return _baseGetFetch(`${path}/product-type`, undefined, ApiEnum.admin)
}

export const getUnitsLanguages = async (queryParams) => {
  return _baseGetFetch(`${path}`, { ...queryParams, maxResults: pageLimit }, ApiEnum.admin)
}

export const addUnitsLanguages = async (body) => {
  return _basePostFetch(`${path}`, body, ApiEnum.admin)
}

export const putUnitsLanguages = async (unitsLanguageId, body) => {
  return _basePutFetch(`${path}/${unitsLanguageId}`, body, ApiEnum.admin)
}

export const deleteUnitsLanguagesTranslation = async (unitsLanguageId) => {
  return _baseDeleteFetch(`${path}/translations/${unitsLanguageId}`, undefined, ApiEnum.admin)
}

export const deleteUnitsLanguages = async (unitsLanguageId) => {
  return _baseDeleteFetch(`${path}/${unitsLanguageId}`, undefined, ApiEnum.admin)
}

export const downloadUnitsLanguages = async (bodyParams) => {
  return _baseGetFetch(`${path}/download`, { ...bodyParams }, ApiEnum.admin)
}
